export default __webpack_public_path__ + "static/media/medium-shield.021ccca5.png";